/*
 * Footy Fits "goes well with" suggestions (rules and wording in the scrapbook admin → Recommendations).
 * 1. On every page: arriving from a suggestion (?ff_rec=<id>) tags the basket with hidden cart attributes, so the
 *    order is credited to that suggestion. Nothing is stored on the device (the tag lives on the basket).
 * 2. On the basket page: a quiet strip of up to a few cards under the basket. Never in checkout, never a pop-up,
 *    and if anything fails the strip just doesn't appear.
 */
(function () {
  var API = "https://scrapbook.footyfits.co.uk/api/recs";
  var ID = /^[0-9a-f-]{36}$/i;

  function beacon(body) {
    try { navigator.sendBeacon(API + "/events", JSON.stringify(body)); } catch (e) {}
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/"; }

  // 1. Tag the basket.
  var rec = new URLSearchParams(location.search).get("ff_rec");
  if (rec && ID.test(rec)) {
    fetch(root() + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { _ff_rec: rec } }),
    }).catch(function () {});
  }

  // 2. The basket strip.
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function lineText(l) {
    var props = l.properties || {};
    var bits = [l.product_title, l.variant_title];
    for (var k in props) if (Object.prototype.hasOwnProperty.call(props, k) && typeof props[k] === "string" && k.charAt(0) !== "_") bits.push(k + ": " + props[k]);
    return bits.filter(Boolean).join(" · ").slice(0, 1500);
  }

  function strip() {
    var box = document.getElementById("ff-recs");
    if (!box) return;
    fetch(root() + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        var lines = cart.items.map(function (l) { return { handle: l.handle, text: lineText(l) }; });
        // The basket now holds what a suggestion pointed to: count the add (once per basket).
        var tagged = cart.attributes && cart.attributes._ff_rec;
        if (tagged && ID.test(tagged)) beacon({ surface: "cart", ref: cart.token, lines: lines, events: [{ r: tagged, e: "add" }] });
        return fetch(API, { method: "POST", headers: { "Content-Type": "text/plain" }, body: JSON.stringify({ surface: "cart", lines: lines }) })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var cards = (data && data.cards) || [];
            if (!cards.length) return;
            box.querySelector(".ff-recs__grid").innerHTML = cards.map(function (c) {
              return '<a class="ff-recs__card" href="' + esc(c.href) + '">' +
                (c.image ? '<img src="' + esc(c.image) + '" alt="" loading="lazy" width="72" height="72">' : "") +
                '<span class="ff-recs__text"><strong>' + esc(c.headline) + "</strong>" +
                (c.body ? "<span>" + esc(c.body) + "</span>" : "") +
                '<span class="ff-recs__cta">' + esc(c.cta) + " &rarr;" + (c.price ? ' <em>' + esc(c.price) + "</em>" : "") + "</span></span></a>";
            }).join("");
            box.hidden = false;
            beacon({ surface: "cart", events: cards.map(function (c) { return { r: c.ruleId, e: "impression" }; }) });
          });
      })
      .catch(function () {});
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", strip);
  else strip();
})();
